// actions
import audienceId from '@/store/actions/audienceId'
import slideOptions from '@/store/actions/slideOptions'
import slides from '@/store/actions/slides'
import presentation from '@/store/actions/presentation'
import currentUser from '@/store/actions/currentUser'
import privateFeedback from '@/store/actions/privateFeedback'
import attendedPresentation from '@/store/actions/attendedPresentation'
import common from '@/store/actions/common'
import sentry from '@/3rd-parties/sentry'

export default {
  ...audienceId,
  ...slideOptions,
  ...slides,
  ...presentation,
  ...currentUser,
  ...privateFeedback,
  ...attendedPresentation,
  ...common,

  setLang: (context, payload) => {
    context.commit('setLang', payload)
  },

  setSlide: ({ state, commit }, payload) => {
    if (!payload) return
    if (state.slideV2 && state.slideV2.id && state.slideV2.receiveTimestamp && state.slideV2.receiveTimestamp > payload.receiveTimestamp && state.slideV2.id == payload.id) {
      sentry.captureException(new Error('Change-slide msg from EMQX is received after Socket.io msg'))
    }

    commit('setSlide', payload)
    commit('setSlideV2', payload)
  },

  // Update Presentation
  updateSlide: (context, payload) => {
    context.commit('updateSlide', payload)
    context.commit('updateSlideV2', payload)
  },

  // Update Presentation
  setConnectionError: (context, payload) => {
    context.commit('setConnectionError', payload)
  },

  setUserLoaded: (context, payload) => {
    context.commit('setUserLoaded', payload)
  },

  setIsLoadingCurrentUserAction: (context, payload) => {
    context.commit('setIsLoadingCurrentUser', payload)
  },
}
